import { render, staticRenderFns } from "./RewardFlow.vue?vue&type=template&id=2d68176f&scoped=true"
import script from "./RewardFlow.vue?vue&type=script&lang=js"
export * from "./RewardFlow.vue?vue&type=script&lang=js"
import style0 from "./RewardFlow.vue?vue&type=style&index=0&id=2d68176f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d68176f",
  null
  
)

export default component.exports